import { makeStyles } from '@material-ui/core/styles';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  flexibleText: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fill: themeColor.subheaderLight,
      width: '100%',
    },
  },
}));
